export enum BreakpointsEnum {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  DESKTOP = 'desktop',
}

export type IBreakpoints = BreakpointsEnum.DESKTOP | BreakpointsEnum.TABLET | BreakpointsEnum.MOBILE
